import { TimePicker as DesignSystemTimePicker } from "@octopusdeploy/design-system-components";
import type { Moment } from "moment";
import * as React from "react";
interface MomentPickerProps {
    time: Moment;
    onTimeChanged(time: Moment): void;
    label?: string;
}
export default function MomentPicker({ time, onTimeChanged, label = "Select a time" }: MomentPickerProps) {
    // Convert Moment to HH:mm format for the native time input
    const timeString = React.useMemo(() => {
        if (!time || !time.isValid()) {
            return "";
        }
        // Format as 24-hour time (HH:mm) which is what HTML time input expects
        return time.format("HH:mm");
    }, [time]);
    const handleTimeChange = React.useCallback((newTimeString: string) => {
        if (!newTimeString) {
            return;
        }
        // Parse the time string (HH:mm format)
        const [hours, minutes] = newTimeString.split(":").map(Number);
        if (isNaN(hours) || isNaN(minutes)) {
            return;
        }
        // Create a new Moment object preserving the original date but updating the time
        const newTime = time.clone();
        newTime.hours(hours);
        newTime.minutes(minutes);
        onTimeChanged(newTime);
    }, [time, onTimeChanged]);
    return <DesignSystemTimePicker value={timeString} onChange={handleTimeChange} label={label}/>;
}
